import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="flex items-center gap-3 group">
      <div className="relative w-9 h-9 flex items-center justify-center overflow-hidden rounded-lg bg-white/5">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvcG5n/15e8582d4567a9306c01c590056a5390.png" 
          alt="GetDMFlow Logo" 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
        />
      </div>
      <span className="text-xl font-bold tracking-tight">
        Get<span className="text-brand-blue">DM</span>Flow<span className="text-brand-cyan text-sm">.com</span>
      </span>
    </Link>
  );
};

export default Logo;